export const GET_USER_INFO = 'getUserInfo';
export const GET_TOKEN = 'getToken';
export const GET_LNG = 'getLng';



// WEBPACK FOOTER //
// ./src/store/getters/type.js